import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
var fileDownload = require("js-file-download");
import axios from "axios";
import { request } from "@/js/http/http_request";
import { isAdminNotConsultant } from "@/js/http/auth.js";
import { getFullNameUserHtml } from "@/js/user/user.js";
import { getErrorData, handleErrorData, ERROR_DATA } from "@/js/forms.js";
import { creditNoteUse, creditNoteItem, listCurrencies } from "@/js/lists.ts";
import { formatPrice, getSymbolCurrency } from "@/js/currency/currencies.js";
import Address from "@/components/address/Address.vue";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
export default {
  props: {
    id: String,
    loggedUserData: Object
  },
  components: {
    Address: Address,
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  data: function data() {
    return {
      isLoading: true,
      creditNote: {},
      gettingFiles: {
        isPending: false,
        results: []
      },
      itemHeaders: [{
        text: "Description",
        value: "description"
      }, {
        text: "SKU",
        value: "sku"
      }, {
        text: "Quantity",
        value: "quantity"
      }, {
        text: "Rate",
        value: "unitPriceCurrency",
        cellClass: "text-nowrap"
      }, {
        text: "Amount",
        value: "amount",
        cellClass: "text-nowrap"
      }],
      useHeaders: [{
        text: "",
        value: "status",
        align: "center",
        width: "150px"
      }, {
        text: "Date",
        value: "creationDate"
      }, {
        text: "Note",
        value: "note"
      }, {
        text: "Amount",
        value: "amountCurrency"
      }],
      exportingPdf: {
        isPending: false,
        cancellationToken: null
      },
      creditNoteUse: creditNoteUse,
      creditNoteItem: creditNoteItem,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    getCurrency: function getCurrency() {
      var _this2 = this;
      return listCurrencies.filter(function (x) {
        return x.implanted_market && x.id === _this2.creditNote.initialCurrency;
      })[0].name;
    },
    getVat: function getVat() {
      return this.creditNote.initialVatRate ? parseFloat(((this.creditNote.initialVatRate - 1) * 100).toFixed(1)) : null;
    },
    getTotalDefaultShippingCurrencyIncluded: function getTotalDefaultShippingCurrencyIncluded() {
      return this.creditNote.items.reduce(function (acc, item) {
        return acc + item.quantity * item.unitDefaultShippingCurrencyIncluded;
      }, 0);
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var id;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (isAdminNotConsultant(_this3.loggedUserData)) {
              _context.next = 3;
              break;
            }
            _this3.$router.push({
              name: "userHome"
            });
            return _context.abrupt("return");
          case 3:
            id = _this3.id;
            _context.next = 6;
            return _this3.fetchCreditNote(id);
          case 6:
            _this3.isLoading = false;
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    fetchCreditNote: function fetchCreditNote(id) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.fetchCnFiles(id);
              _this = _this4;
              _context2.next = 4;
              return request("/v1/credit-notes/".concat(id), "get", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to load current credit note.", {
                  type: "error"
                });
                throw e;
              });
            case 4:
              response = _context2.sent;
              _this4.creditNote = _objectSpread(_objectSpread({}, response.data.value), {}, {
                creationDate: new Date(response.data.value.creationDate).toLocaleDateString("en-US")
              });
              _this4.creditNote.items = _this4.creditNote.items.map(function (x) {
                return {
                  type: x.type,
                  description: x.wineId ? x.wine.display_name : x.description,
                  sku: x.wineId ? x.wine.sku : "",
                  quantity: x.quantity,
                  amount: x.amountCurrency,
                  unitPriceCurrency: x.unitPriceCurrency,
                  unitDefaultShippingCurrencyIncluded: x.unitDefaultShippingCurrencyIncluded
                };
              });
              if (_this4.creditNote.uses) {
                _this4.creditNote.uses = _this4.creditNote.uses.map(function (x) {
                  return _objectSpread(_objectSpread({}, x), {}, {
                    note: x.order.id ? x.order.displayReferenceOrder : x.refundingNote,
                    creationDate: new Date(x.creationDate).toLocaleDateString("en-US")
                  });
                });
              }
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    fetchCnFiles: function fetchCnFiles(id) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, resp;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.gettingFiles.results = [];
              _this5.gettingFiles.isPending = true;
              _this = _this5;
              _context3.next = 5;
              return request("/v1/credit-notes/".concat(id, "/files/cn"), "get", null, true, "api", null).catch(function (_) {
                _this.$toasted.show("Unable to download the credit note's files.", {
                  type: "error"
                });
                _this.gettingFiles.isPending = false;
              });
            case 5:
              resp = _context3.sent;
              _this5.gettingFiles.results = _toConsumableArray(resp.data.value);
              _this5.gettingFiles.isPending = false;
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getPackingList: function getPackingList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this$exportingPdf$ca;
        var _this, response, url;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this6.exportingPdf.isPending = true;
              _this = _this6;
              (_this$exportingPdf$ca = _this.exportingPdf.cancellationToken) === null || _this$exportingPdf$ca === void 0 || _this$exportingPdf$ca.cancel();
              _this.exportingPdf.cancellationToken = axios.CancelToken.source();
              _context5.next = 6;
              return request("/v1/credit-notes/".concat(_this6.creditNote.id, "/pdf/packing-list"), "get", null, true, "api", null, _this.exportingPdf.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.exportingPdf.isPending = false;
                          errorData = getErrorData(e, {}, "Unable to get PDF.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 6:
              response = _context5.sent;
              url = response.data.value.url;
              _this6.openUrl(url);
              _this6.exportingPdf.isPending = false;
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    openIssuingCmFrFile: function openIssuingCmFrFile() {
      var _this$gettingFiles$re;
      var url = (_this$gettingFiles$re = this.gettingFiles.results) === null || _this$gettingFiles$re === void 0 || (_this$gettingFiles$re = _this$gettingFiles$re.find(function (x) {
        return x.isCmFrIssuing;
      })) === null || _this$gettingFiles$re === void 0 ? void 0 : _this$gettingFiles$re.url;
      if (url) {
        this.openUrl(url);
      }
    },
    openIssuingImporterFile: function openIssuingImporterFile() {
      var _this$gettingFiles$re2;
      var url = (_this$gettingFiles$re2 = this.gettingFiles.results) === null || _this$gettingFiles$re2 === void 0 || (_this$gettingFiles$re2 = _this$gettingFiles$re2.find(function (x) {
        return !x.isCmFrIssuing;
      })) === null || _this$gettingFiles$re2 === void 0 ? void 0 : _this$gettingFiles$re2.url;
      if (url) {
        this.openUrl(url);
      }
    },
    openUrl: function openUrl(url) {
      window.open(url, "_blank");
    },
    exit: function exit() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this7.$router.push({
                name: "adminOrderList",
                query: {
                  tab: "creditNote"
                }
              });
            case 1:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    toOrderDetails: function toOrderDetails(orderId) {
      return {
        name: "adminOrderSummary",
        params: {
          id: orderId
        }
      };
    },
    formatPrice: formatPrice,
    getSymbolCurrency: getSymbolCurrency,
    getFullNameUserHtml: getFullNameUserHtml
  }
};